export function getClinetPageCategories() {
    const {
        category,
        categoryId,
        categories = [],
    } = window.clientData?.resultsPage?.categories || {};
    const [subcategory1, subcategory2, subcategory3, subcategory4, subcategory5] = categories;
    return {
        category,
        categoryId,
        subcategory1,
        subcategory2,
        subcategory3,
        subcategory4,
        subcategory5,
    };
}
